import { render, staticRenderFns } from "./RegisterAssessment.vue?vue&type=template&id=53092f95"
import script from "./RegisterAssessment.vue?vue&type=script&lang=js"
export * from "./RegisterAssessment.vue?vue&type=script&lang=js"
import style0 from "./RegisterAssessment.vue?vue&type=style&index=0&id=53092f95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports